import {type ActionTree} from 'vuex';
import LocalStorage from '../../../library/localStorage';
import {HasNotifications} from '../../../library/notification';
import {NoOperation} from '../../../library/utils';
import store from '../../index';

let initialized = false;

const actions: ActionTree<NotificationState, RootState> = {
    fetch({
        commit,
        dispatch,
        state,
    }, {data, router})
    {
        commit('update', data);
        commit('update', {lastTimestamp: Date.now()});
        dispatch('updateCount', {count: state.count});

        // broadcast newly fetched entry-read-states
        if (typeof data.entries !== 'undefined')
        {
            let markAsReadIds = [];

            for (let entry of <NotificationEntry[]>data.entries)
            {
                if (entry.read)
                {
                    markAsReadIds.push(entry.id);
                }
            }

            if (markAsReadIds.length)
            {
                LocalStorage.set('notificationMarkAsRead', markAsReadIds.join('_'));
            }
        }

        // functionality not available or no new desktop notification
        if (!HasNotifications || !data.lastNotification)
        {
            return;
        }

        // check for permission to send desktop notification
        window.Notification.requestPermission().then((permission) =>
        {
            // permission denied
            if (permission === 'denied' || permission === 'default')
            {
                return;
            }

            // send desktop notification
            let notification = new window.Notification(data.lastNotification.title, data.lastNotification);

            if (data.lastNotification.link)
            {
                notification.onclick = function()
                {
                    window.focus();
                    notification.close();
                    router.push(data.lastNotification.link).catch(console.error);
                };
            }
        });
    },
    updateCount({
        commit,
        dispatch,
        state,
        getters,
    }, {count, broadcast = true})
    {
        if (!initialized)
        {
            initialized = true;

            LocalStorage.on('notificationUnreadCount', event =>
            {
                const [storageCount, storageTimestamp] = event.newValue.split('_').map(Number);

                // update count if latest timestamp is outdated
                if (getters.latestTimestamp < storageTimestamp)
                {
                    commit('update', {lastStorageTimestamp: storageTimestamp});
                    dispatch('updateCount', {count: storageCount, broadcast: false});
                }
            });

            LocalStorage.on('notificationMarkAsRead', event =>
            {
                let newValue = String(event.newValue);

                commit('markEntriesAsRead', newValue === 'all' ? newValue : newValue.split('_').map((id: string) => parseInt(id)));
            });
        }

        if (typeof count === 'number')
        {
            commit('update', {count});
        }

        if (broadcast)
        {
            LocalStorage.set('notificationUnreadCount', state.count + '_' + getters.latestTimestamp);
        }

        store.dispatch('updateFaviconBadge').then(NoOperation).catch(NoOperation);
    },
    markAsRead({
        commit,
        dispatch,
        state,
    }, id)
    {
        commit('markAsRead', id);
        dispatch('updateCount', {count: state.count});
        LocalStorage.set('notificationMarkAsRead', id);
    },
    markAllAsRead({
        commit,
        dispatch,
        state,
    })
    {
        commit('markAllAsRead');
        dispatch('updateCount', {count: state.count});
        LocalStorage.set('notificationMarkAsRead', 'all');
    },
};

export default actions;